const HEADING_WAIT_MS = 10_000

function focusTarget(element: HTMLElement): void {
  if (!element.hasAttribute("tabindex")) element.setAttribute("tabindex", "-1")
  element.focus()
}

export function focusPageHeading(pageName: string): () => void {
  const main = document.querySelector("main")
  if (!main) return () => {}

  const heading = main.querySelector("h1")
  if (heading) {
    focusTarget(heading)
    return () => {}
  }

  if (!main.hasAttribute("aria-label") && !main.hasAttribute("aria-labelledby")) {
    main.setAttribute("aria-label", pageName)
  }
  focusTarget(main)
  const observer = new MutationObserver(() => {
    const rendered = main.querySelector("h1")
    if (!rendered) return
    stop()
    if (document.activeElement === main) focusTarget(rendered)
  })
  const timer = setTimeout(stop, HEADING_WAIT_MS)
  function stop(): void {
    observer.disconnect()
    clearTimeout(timer)
  }
  observer.observe(main, { childList: true, subtree: true })
  return stop
}
